<div class="detail-container">
    <mat-toolbar color="secondary">
        <mat-toolbar-row class="ticket-info-bar">
            <h1>Ticket</h1>
            <h1 *ngIf="pTicket">{{ pTicket.id }}</h1>
            <!--h1 *ngIf="pTicket && pTicket.pct_status === 'closed'"><mat-icon>lock</mat-icon></h1-->
            <h1 *ngIf="pTicket && pTicket.pct_status === 'closed'">({{ pTicket.pct_status }})</h1>
            <h1 style="display: flex;"><mat-icon
                    matTooltip="This ticket ({{ pTicket.pct_organization }}) does not belong to your current organization. Editing is disabled."
                    color="primary" *ngIf="pTicket.pct_organization != globalUser.getUser().org_name">warning</mat-icon>
            </h1>
            <span class="example-spacer"></span>
            <h1>Support level</h1>
            <h1 *ngIf="pTicket"> {{ pTicket.pct_supportlevel }}</h1>
        </mat-toolbar-row>

    </mat-toolbar>


    <mat-tab-group mat-stretch-tabs="true" style="height: 100%;" *ngIf="pTicket">
        <mat-tab label="Ticket Communication">
            <div class="actions-bar" *ngIf="pTicket">
                <!--div matTooltip="Coming soon" [matTooltipDisabled]="false" *ngIf="pTicket.pct_status === 'open'">
                    <button mat-button [disabled]="true">Upload file<mat-icon>file_copy</mat-icon></button>
                </div-->

                <!-- Close ticket button -->
                <button *ngIf="pTicket.pct_status === 'open' && !isClosingTicket" mat-button (click)="onCloseTicket()"
                    [disabled]="!ticketUpdatePermission">Close
                    ticket<mat-icon>lock</mat-icon></button>
                <button mat-button disabled="true"
                    *ngIf="pTicket.pct_status === 'open' && isClosingTicket"><mat-icon><mat-spinner
                            diameter="17"></mat-spinner></mat-icon>Close
                    ticket</button>

                <!-- Delete Ticket Button -->
                <span [matTooltip]="!canDeleteTicket ? 'You do not have permission to delete this ticket' : ''"
                    *ngIf="pTicket.pct_status === 'closed'&& !isReopeningTicket">
                    <button mat-button (click)="onDeleteTicket()" [disabled]="!canDeleteTicket">
                        Delete Ticket <mat-icon>delete</mat-icon>
                    </button>
                </span>
                <!-- Reopen Ticket Button  -->

                <button *ngIf="pTicket.pct_status === 'closed'&& !isReopeningTicket" mat-button
                    (click)="onReopenTicket()" [disabled]="!ticketUpdatePermission">Reopen
                    ticket<mat-icon>lock_open</mat-icon></button>
                <button mat-button disabled="true"
                    *ngIf="pTicket.pct_status === 'closed' && isReopeningTicket"><mat-icon><mat-spinner
                            diameter="17"></mat-spinner></mat-icon>Reopen
                    ticket</button>


                <!-- new description button -->
                <button mat-raised-button color="primary" (click)="onAddDescription()"
                    *ngIf="pTicket.pct_status === 'open'" [disabled]="!ticketUpdatePermission">New
                    description<mat-icon>add</mat-icon></button>
            </div>

            <app-descriptions-history-view *ngIf="pTicket" [pDescriptions]="pDescriptions"
                (pDescriptionAddedEmitter)="pDescriptionAddedEventFired($event)" [pTicket]="pTicket"
                [canUpdate]="!this.ticketUpdatePermission"></app-descriptions-history-view>
        </mat-tab>

        <mat-tab label="Ticket Info">
            <div class="actions-bar" *ngIf="pTicket">
                <!-- Close ticket button -->
                <button *ngIf="pTicket.pct_status === 'open' && !isClosingTicket" mat-button (click)="onCloseTicket()"
                    [disabled]="!ticketUpdatePermission">Close
                    ticket<mat-icon>lock</mat-icon></button>
                <button mat-button disabled="true"
                    *ngIf="pTicket.pct_status === 'open' && isClosingTicket"><mat-icon><mat-spinner
                            diameter="17"></mat-spinner></mat-icon>Close
                    ticket</button>

                <!-- Delete Ticket Button -->
                <span [matTooltip]="!canDeleteTicket ? 'You do not have permission to delete this ticket' : ''"
                    *ngIf="pTicket.pct_status === 'closed'&& !isReopeningTicket">
                    <button mat-button (click)="onDeleteTicket()" [disabled]="!canDeleteTicket">
                        Delete Ticket <mat-icon>delete</mat-icon>
                    </button>
                </span>
                <!-- Reopen Ticket Button  -->
                <button *ngIf="pTicket.pct_status === 'closed'&& !isReopeningTicket" mat-button
                    (click)="onReopenTicket()" [disabled]="!ticketUpdatePermission">Reopen
                    ticket<mat-icon>lock_open</mat-icon></button>
                <button mat-button disabled="true"
                    *ngIf="pTicket.pct_status === 'closed' && isReopeningTicket"><mat-icon><mat-spinner
                            diameter="17"></mat-spinner></mat-icon>Reopen
                    ticket</button>
                <!-- Update ticket button -->
                <button mat-raised-button color="primary" (click)="onUpdateTicketInfo()"
                    *ngIf="pTicket.pct_status === 'open' && !isUpdatingTicket"
                    [disabled]="!ticketUpdatePermission">Update ticket info<mat-icon>save</mat-icon></button>
                <button mat-button disabled="true"
                    *ngIf="pTicket.pct_status === 'open' && isUpdatingTicket"><mat-icon><mat-spinner
                            diameter="17"></mat-spinner></mat-icon>Update
                    ticket</button>

            </div>
            <app-p-keyword-picker [pTicket]="pTicket" *ngIf="pTicket"
                [canUpdate]="!this.ticketUpdatePermission"></app-p-keyword-picker>
            <app-p-ticket-edit-ticket-data (pDescriptionAddedEmitter)="pDescriptionAddedEventFired($event)"
                *ngIf="pTicket" [pTicket]="pTicket"
                [canUpdate]="!this.ticketUpdatePermission"></app-p-ticket-edit-ticket-data>
        </mat-tab>

        <mat-tab label="User Info">
            <div class="actions-bar" *ngIf="pTicket">
                <!-- Close ticket button -->
                <button *ngIf="pTicket.pct_status === 'open' && !isClosingTicket" mat-button
                    [disabled]="!ticketUpdatePermission" (click)="onCloseTicket()">Close
                    ticket<mat-icon>lock</mat-icon></button>
                <button mat-button disabled="true"
                    *ngIf="pTicket.pct_status === 'open' && isClosingTicket"><mat-icon><mat-spinner
                            diameter="17"></mat-spinner></mat-icon>Close
                    ticket</button>

                <!-- Delete Ticket Button -->
                <span [matTooltip]="!canDeleteTicket ? 'You do not have permission to delete this ticket' : ''"
                    *ngIf="pTicket.pct_status === 'closed'&& !isReopeningTicket">
                    <button mat-button (click)="onDeleteTicket()" [disabled]="!canDeleteTicket">
                        Delete Ticket <mat-icon>delete</mat-icon>
                    </button>
                </span>

                <!-- Reopen Ticket Button  -->
                <button *ngIf="pTicket.pct_status === 'closed'&& !isReopeningTicket" mat-button
                    [disabled]="!ticketUpdatePermission" (click)="onReopenTicket()">Reopen
                    ticket<mat-icon>lock_open</mat-icon></button>
                <button mat-button disabled="true"
                    *ngIf="pTicket.pct_status === 'closed' && isReopeningTicket"><mat-icon><mat-spinner
                            diameter="17"></mat-spinner></mat-icon>Reopen
                    ticket</button>

                <!-- Update ticket button -->
                <button mat-raised-button color="primary" [disabled]="!ticketUpdatePermission"
                    (click)="onUpdateUserInfo()" *ngIf="pTicket.pct_status === 'open' && !isUpdatingTicket">Update user
                    info<mat-icon>save</mat-icon></button>
                <button mat-button disabled="true"
                    *ngIf="pTicket.pct_status === 'open' && isUpdatingTicket"><mat-icon><mat-spinner
                            diameter="17"></mat-spinner></mat-icon>Update
                    ticket</button>
            </div>
            <app-p-ticket-edit-user-data (pDescriptionAddedEmitter)="pDescriptionAddedEventFired($event)"
                *ngIf="pTicket" [pTicket]="pTicket"
                [canUpdate]="!this.ticketUpdatePermission"></app-p-ticket-edit-user-data>

        </mat-tab>
    </mat-tab-group>

    <mat-tab-group *ngIf="!pTicket">
        <mat-tab label="Ticket Communication"></mat-tab>
        <mat-tab label="Ticket Info"></mat-tab>
        <mat-tab label="User Info"></mat-tab>
    </mat-tab-group>
    <div style="display: flex; justify-content: center; align-items: center; height: 100%;" *ngIf="!pTicket">
        <mat-spinner></mat-spinner>
    </div>
</div>